(() => {
  const ROOT_SELECTOR = '[data-tvati-pack-comparison]';
  const PROBE_SELECTOR = '[data-tvati-pack-bss-probe]';
  const PRICE_SELECTOR = '[data-tvati-pack-b2b-price]';

  const parseMoneyText = (text) => {
    if (!text) return null;

    const cleaned = text
      .replace(/\s+/g, '')
      .replace(/[^\d.,-]/g, '');

    if (!cleaned) return null;

    const lastDot = cleaned.lastIndexOf('.');
    const lastComma = cleaned.lastIndexOf(',');
    let normalised = cleaned;

    if (lastComma > lastDot) {
      normalised = cleaned.replace(/\./g, '').replace(',', '.');
    } else {
      normalised = cleaned.replace(/,/g, '');
    }

    const value = Number.parseFloat(normalised);
    return Number.isFinite(value) ? value : null;
  };

  const getBssResolvedPrice = (probe) => {
    if (!probe) return null;

    const descendants = [...probe.querySelectorAll('span')]
      .map((node) => parseMoneyText(node.textContent))
      .filter((value) => value !== null);

    if (descendants.length) {
      return descendants[descendants.length - 1];
    }

    return parseMoneyText(probe.textContent);
  };

  const formatCents = (cents, currency) => {
    const activeCurrency =
      currency ||
      window.Shopify?.currency?.active ||
      window.Shopify?.currency?.shop_currency ||
      'USD';

    const locale = document.documentElement.lang || 'en-US';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: activeCurrency
      }).format(cents / 100);
    } catch (error) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const resolveProduct = (root, probe) => {
    if (!root || !probe) return false;

    const productId = String(probe.dataset.productId || '');
    const baseRetailCents = Number(probe.dataset.bssBaseRetailCents);

    if (!productId || !Number.isFinite(baseRetailCents) || baseRetailCents <= 0) {
      return false;
    }

    const bssPrice = getBssResolvedPrice(probe);
    if (bssPrice === null) return false;

    const bssProcessed =
      probe.hasAttribute('bss-b2b-product-active') ||
      probe.querySelectorAll('span').length > 0;

    if (!bssProcessed) return false;

    const bssCents = Math.round(bssPrice * 100);
    const factor = bssCents / baseRetailCents;

    if (!Number.isFinite(factor) || factor <= 0 || factor > 2) {
      return false;
    }

    const currency = root.dataset.currency || 'USD';

    root.querySelectorAll(PRICE_SELECTOR).forEach((wrapper) => {
      if (String(wrapper.dataset.productId || '') !== productId) return;

      const variantRetailCents = Number(wrapper.dataset.variantRetailCents);
      if (!Number.isFinite(variantRetailCents)) return;

      const resolvedCents = Math.round(variantRetailCents * factor);
      const retail = wrapper.querySelector('[data-tvati-pack-b2b-retail-price]');
      const output = wrapper.querySelector('[data-tvati-pack-b2b-resolved-price]');

      if (!output) return;

      output.textContent = formatCents(resolvedCents, currency);
      output.hidden = false;
      output.dataset.tvatiB2bResolved = 'true';
      wrapper.dataset.tvatiB2bFactor = factor.toFixed(6);

      if (retail) {
        retail.hidden = resolvedCents === variantRetailCents;
      }
    });

    return true;
  };

  const initProbe = (root, probe) => {
    if (!root || !probe || probe.dataset.tvatiPackB2bReady === 'true') return;

    const resolve = () => resolveProduct(root, probe);
    resolve();

    const observer = new MutationObserver(resolve);
    observer.observe(probe, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['bss-b2b-product-active', 'style']
    });

    probe.dataset.tvatiPackB2bReady = 'true';
  };

  const initRoot = (root) => {
    if (!root) return;
    root.querySelectorAll(PROBE_SELECTOR).forEach((probe) => initProbe(root, probe));
  };

  const init = (scope = document) => {
    if (scope.matches?.(ROOT_SELECTOR)) initRoot(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('bss_b2b_doneCheckCp', () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      root.querySelectorAll(PROBE_SELECTOR).forEach((probe) => {
        window.requestAnimationFrame(() => resolveProduct(root, probe));
      });
    });
  });
})();
